export default __webpack_public_path__ + "f547b7aa8dbbd1d9fd32b7d7aa74a414.jpg";